import { action, createRequestTypes } from '../../base';

export const gateDocumentActionTypes = {
  GET_GATE_DOCUMENT_BY_ID: createRequestTypes('GET_GATE_DOCUMENT_BY_ID'),
  CREATE_GATE_DOCUMENT: createRequestTypes('CREATE_GATE_DOCUMENT'),
  GET_GATE_DOCUMENTS: createRequestTypes('GET_GATE_DOCUMENTS'),
  LINK_CONTACTS: createRequestTypes('LINK_CONTACTS'),
  UNLINK_CONTACTS: createRequestTypes('UNLINK_CONTACTS'),
  LINK_DOCUMENTS: createRequestTypes('LINK_DOCUMENTS'),
  UNLINK_DOCUMENTS: createRequestTypes('UNLINK_DOCUMENTS'),
  UPDATE_DOCUMENT_STATUS: createRequestTypes('UPDATE_DOCUMENT_STATUS'),
  QUICK_UPDATE_GATE_DOCUMENT: createRequestTypes('QUICK_UPDATE_GATE_DOCUMENT'),
};

class GateDocumentActions {
  getGateDocumentById = (payload, callback) => action(gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.REQUEST, {
    payload, callback,
  })

  getGateDocumentByIdLoading = (getGateDocumentByIdLoading) => action(gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.LOADING, {
    getGateDocumentByIdLoading,
  })

  getGateDocumentByIdSuccess = (selectedGateDocument) => action(gateDocumentActionTypes.GET_GATE_DOCUMENT_BY_ID.SUCCESS, {
    selectedGateDocument,
  })

  createGateDocument = (payload, callback) => action(gateDocumentActionTypes.CREATE_GATE_DOCUMENT.REQUEST, {
    payload, callback,
  })

  createGateDocumentLoading = (createGateDocumentLoading) => action(gateDocumentActionTypes.CREATE_GATE_DOCUMENT.LOADING, {
    createGateDocumentLoading,
  })

  getGateDocuments = (payload, callback) => action(gateDocumentActionTypes.GET_GATE_DOCUMENTS.REQUEST, {
    payload, callback,
  })

  getGateDocumentsLoading = (getGateDocumentsLoading) => action(gateDocumentActionTypes.GET_GATE_DOCUMENTS.LOADING, {
    getGateDocumentsLoading,
  })

  getGateDocumentsSuccess = (gateDocuments) => action(gateDocumentActionTypes.GET_GATE_DOCUMENTS.SUCCESS, {
    gateDocuments,
  })

  linkContacts = (payload, callback) => action(gateDocumentActionTypes.LINK_CONTACTS.REQUEST, {
    payload, callback,
  })

  linkContactsLoading = (linkContactsLoading) => action(gateDocumentActionTypes.LINK_CONTACTS.LOADING, {
    linkContactsLoading,
  })

  unlinkContacts = (payload, callback) => action(gateDocumentActionTypes.UNLINK_CONTACTS.REQUEST, {
    payload, callback,
  })

  unlinkContactsLoading = (unlinkContactsLoading) => action(gateDocumentActionTypes.UNLINK_CONTACTS.LOADING, {
    unlinkContactsLoading,
  })

  linkDocuments = (payload, callback) => action(gateDocumentActionTypes.LINK_DOCUMENTS.REQUEST, {
    payload, callback,
  })

  linkDocumentsLoading = (linkDocumentsLoading) => action(gateDocumentActionTypes.LINK_DOCUMENTS.LOADING, {
    linkDocumentsLoading,
  })

  unlinkDocuments = (payload, callback) => action(gateDocumentActionTypes.UNLINK_DOCUMENTS.REQUEST, {
    payload, callback,
  })

  unlinkDocumentsLoading = (unlinkDocumentsLoading) => action(gateDocumentActionTypes.UNLINK_DOCUMENTS.LOADING, {
    unlinkDocumentsLoading,
  })

  updateDocumentStatus = (payload, callback) => action(gateDocumentActionTypes.UPDATE_DOCUMENT_STATUS.REQUEST, {
    payload, callback,
  })

  updateDocumentStatusLoading = (updateDocumentStatusLoading) => action(gateDocumentActionTypes.UPDATE_DOCUMENT_STATUS.LOADING, {
    updateDocumentStatusLoading,
  })

  quickUpdateGateDocument = (payload, callback) => action(gateDocumentActionTypes.QUICK_UPDATE_GATE_DOCUMENT.REQUEST, {
    payload, callback,
  })

  quickUpdateGateDocumentLoading = (quickUpdateGateDocumentLoading) => action(gateDocumentActionTypes.QUICK_UPDATE_GATE_DOCUMENT.LOADING, {
    quickUpdateGateDocumentLoading,
  })
}

export default new GateDocumentActions();
